import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { DiscrepancyProps } from "../../../../../types/discrepancy";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onView: (id: number) => void;
  data: DiscrepancyProps[];
  [x: string]: any;
}
export default function DataTable({
  onEdit,
  onDelete,
  onView,
  data = [],
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Discrepancy - Maintenance") ||
            hasClaim("Discrepancy - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_DIVERGENCIA}`}
        icon={<VisibilityIcon />}
        data-testid="view-button"
        label="View"
        onClick={() => onView(row.ID_DIVERGENCIA)}
        color="inherit"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Discrepancy - Maintenance") ? "block" : "none",
        }}
        key={`edit-${row.ID_DIVERGENCIA}`}
        icon={<EditIcon />}
        data-testid="edit-button"
        label="Edit"
        className="textPrimary"
        onClick={() => onEdit(row.ID_DIVERGENCIA)}
        color="inherit"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Discrepancy - Maintenance") ? "block" : "none",
        }}
        key={`delete-${row.ID_DIVERGENCIA}`}
        icon={<DeleteIcon />}
        label="Delete"
        data-testid="delete-button"
        onClick={() => onDelete(row.ID_DIVERGENCIA)}
        color="inherit"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "DSC_DIVERGENCIA",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "DSC_MENSAGEM",
      headerName: "Message",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data?.map((row) => row.ID_DIVERGENCIA)}
        data-testid="unit-data-table"
        data={data}
        columns={columns}
        getRowHeight={() => 60}
        {...props}
      />
    </>
  );
}
